import { useState, useEffect } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function EmailHistoryDialog({ open, onClose }) {
  const [history, setHistory] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const token = localStorage.getItem("session_token");

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/admin/emails`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setHistory(res.data))
      .catch(() => setHistory([]));
  }, [open, token]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="email-history-dialog">
        <DialogHeader>
          <DialogTitle>Sent Email History</DialogTitle>
        </DialogHeader>
        {history.length === 0 ? (
          <p className="text-sm text-slate-500 py-8 text-center" data-testid="email-history-empty">No emails sent yet.</p>
        ) : (
          <div className="space-y-2">
            {history.map((h) => (
              <div key={h.id} className="border rounded-lg p-3 bg-white" data-testid={`email-history-${h.id}`}>
                <button className="w-full text-left" onClick={() => setExpanded(expanded === h.id ? null : h.id)}>
                  <div className="flex justify-between items-start gap-3">
                    <div className="min-w-0">
                      <p className="font-semibold text-sm truncate" style={{ color: "#092036" }}>{h.subject}</p>
                      <p className="text-xs text-slate-500">
                        {new Date(h.sent_at).toLocaleString()} · by {h.sent_by}
                      </p>
                    </div>
                    <div className="text-xs whitespace-nowrap flex gap-2">
                      <span className="text-green-700 flex items-center gap-1"><CheckCircle className="w-3 h-3" />{h.sent_count}</span>
                      {h.failed_count > 0 && <span className="text-red-600 flex items-center gap-1"><XCircle className="w-3 h-3" />{h.failed_count}</span>}
                    </div>
                  </div>
                </button>
                {expanded === h.id && (
                  <div className="mt-3 pt-3 border-t space-y-2">
                    <p className="text-sm whitespace-pre-wrap text-slate-700">{h.message}</p>
                    <div className="text-xs text-slate-600 max-h-32 overflow-y-auto">
                      {h.recipients.map((r) => (
                        <div key={r.email} className="flex justify-between py-0.5">
                          <span>{r.name || r.email} &lt;{r.email}&gt;</span>
                          <span className={r.status === "sent" ? "text-green-700" : "text-red-600"} title={r.error || ""}>{r.status}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
